export default __webpack_public_path__ + "static/media/BackgroundPwa.c6e1b3f1.png";